import {
	API_BASE,
	API_ENDPOINT_ALERTS
} from '@/constants/index'

const FETCH_INTERVAL = 30000

const fetchAlerts = () => {
	fetch(`${API_BASE}${API_ENDPOINT_ALERTS}`)
		.then(response => response.json())
		.then(data => {
			if (!data.length) {
				return
			}
			self.postMessage(data)
		})
		.catch(error => {
			self.postMessage({
				isError: true,
				error
			})
		})
	setTimeout(fetchAlerts, FETCH_INTERVAL)
}

fetchAlerts()
